import { PERMISSIONS } from "@/constants/permissions"
import useUser from "@/hooks/useUser"
import { useSearchParams } from "react-router"
import { CustomerActiveWorkSection } from "../../shared/CustomerActiveWorkSection"
import { EntityEmptyDetail } from "../../shared/EntityEmptyDetail"
import { GenerateConformityPanel } from "../../shared/GenerateConformityPanel"
import { ProductArticlesSection } from "./ProductArticlesSection"
import { ProductAuditSection } from "./ProductAuditSection"
import { ProductCustomersSection } from "./ProductCustomersSection"
import {
  ProductFieldsBody,
  ProductFieldsHeader,
  useProductFieldsState,
} from "./ProductFieldsSection"

interface ProductDetailPanelProps {
  selectedIds: Set<string>
  onRemoveIds: (ids: string[]) => void
}

export function ProductDetailPanel({
  selectedIds,
  onRemoveIds,
}: ProductDetailPanelProps) {
  const [searchParams] = useSearchParams()
  const id = searchParams.get("id")
  const fieldsState = useProductFieldsState()
  const { hasPermission } = useUser()
  const canSeeActiveWork =
    hasPermission(PERMISSIONS.MC_QUESTIONNAIRES_VIEW) ||
    hasPermission(PERMISSIONS.MC_CUSTOMER_DECLARATIONS_VIEW)

  if (selectedIds.size > 0) {
    return (
      <GenerateConformityPanel
        entityType="product"
        selectedIds={selectedIds}
        onRemoveIds={onRemoveIds}
      />
    )
  }

  if (!id) return <EntityEmptyDetail body="MC_MD_EMPTY_SELECT_BODY_PRODUCT" />

  return (
    <div className="flex flex-col">
      <ProductFieldsHeader state={fieldsState} />
      {canSeeActiveWork && (
        <CustomerActiveWorkSection scope="product" entityId={id} />
      )}
      <ProductArticlesSection />
      <ProductCustomersSection />
      <ProductFieldsBody state={fieldsState} />
      <ProductAuditSection />
    </div>
  )
}
